/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { createContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// @image
import { DashboardStyles } from "../../assets/css/dashboard-style";

// @components
import {
  Box,
  Container,
  CssBaseline,
  IconButton,
  Typography,
} from "../../components/shared/MaterialUI.js";
import { ClientTable } from "./components/ClientTable";
import { StatsBoxes } from "./components/StatsBoxes";
import Pageheader from "../../components/PageHeader.js";
import BulkFiles from "./components/BulkFiles.js";
import ToggleCollapse from "./components/ToggleCollapse.jsx";

// @helpers
import { ROUTENAME } from "../../navigation/RouteName.js";
import { LISTROLES } from "../../helpers/ListRoles.js";

// @hooks
import useStats from "../searchEmployer/hooks/UseStats.js";
import useAdmin from "./hooks/UseAdmin.js";

const Dashboard = () => {
  const state = useSelector((loadedState) => loadedState);
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchText = queryParams.get('search') || '';
  const user = state.user;
  const styles = useMemo(() => DashboardStyles(), []);
  const dispatch = useDispatch();
  const organizationId = state?.organizationReducer?.organizationSelected?.id;
  const organizationName = state?.organizationReducer?.organizationSelected?.name;
  const isMonday = new Date().getDay() === 1; // 0: Domingo, 1: Lunes, ..., 6: Sábado

  if (!user?.accessToken) {
    history.push(ROUTENAME.login);
  }

  const {
    rowsState,
    getAllCompanies,
    setRowsState,
    sortModel,
  } = useAdmin();

  const {stats, fetchStats} = useStats(organizationId);
  const [isContainerOpen, setIsContainerOpen] = useState(false);

  useEffect(() => {
    if(user?.hasNewToken && !user?.expiryTime){
      dispatch({ type: 'LOGOUT' })
    };
  }, [])

  useEffect(() => {
    if(searchText) getAllCompanies({filters: {name: searchText}});
    if(!searchText) getAllCompanies();
    fetchStats();
    setIsContainerOpen(false);
  }, [organizationId])

  return (
    <>
      <CssBaseline />
      <Container
        component="section"
        maxWidth="xl"
        sx={styles.dashCtn}
      >
        <Container
          component="div"
          maxWidth="xl"
          sx={{
            ...styles.upperCtn,
            marginBottom: '25px',
          }}
        >
          <Pageheader
            title={'Dashboard'}
            subtitle={`Welcome to ${organizationName} dashboard`}
          />
        </Container>
        
        {isMonday && user.role === LISTROLES.superAdmin &&
          <BulkFiles/>
        }

        <Box maxWidth="xl" sx={styles.buttonCtn} >
          <StatsBoxes stats={stats} />
        </Box>

        <Box maxWidth="xl" sx={styles.toggleContainer}>
          <Box sx={styles.toggleContainerButtons}>
            <IconButton
              color="primary"
              aria-label="toggle container"
              onClick={() => setIsContainerOpen(!isContainerOpen)}
            >
            {!isContainerOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </IconButton>

            <Typography variant="body1" sx={styles.toggleContainerText}>
              {isContainerOpen ? 'Hide section' : 'More statistics...'}
            </Typography>
          </Box>

          <ToggleCollapse isContainerOpen={isContainerOpen} />
        </Box>

        <DataTable.Provider
          value={{
            rowsState,
            getAllCompanies,
            setRowsState,
            sortModel
          }}
        >
          <ClientTable accessToken={user?.accessToken} />
        </DataTable.Provider>
      </Container>
    </>
  );
};

export const DataTable = createContext({});
export default Dashboard;
